import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "text-center"
};
const _hoisted_2 = { key: 1 };
import { computed } from 'vue';
import { useStore } from 'vuex';
import ReportStatusDropdownItem from './ReportStatusDropdownItem.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ReportsStatusDropdown',
    emits: ["removeBadge"],
    setup(__props, { emit }) {
        const store = useStore();
        const reportFiles = computed(() => store.state.reports.reportFiles);
        async function handleShow() {
            await store.dispatch('reports/fetchReportFiles');
            emit('removeBadge');
        }
        return (_ctx, _cache) => {
            const _component_BaseIcon = _resolveComponent("BaseIcon");
            const _component_b_dropdown = _resolveComponent("b-dropdown");
            return (_openBlock(), _createBlock(_component_b_dropdown, {
                "no-caret": "",
                right: "",
                class: "reports-dropdown",
                boundary: "scrollParent",
                variant: "link",
                "toggle-class": "text-decoration-none",
                onShow: _cache[0] || (_cache[0] = ($event) => (handleShow()))
            }, {
                "button-content": _withCtx(() => [
                    _createVNode(_component_BaseIcon, {
                        class: "text-white",
                        name: "download"
                    })
                ]),
                default: _withCtx(() => [
                    (reportFiles.value.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No report is generated. "))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportFiles.value, (report) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: report.name
                                }, [
                                    _createVNode(ReportStatusDropdownItem, { report: report }, null, 8, ["report"])
                                ]));
                            }), 128))
                        ]))
                ], undefined, true),
                _: 1
            }));
        };
    }
});
